import Decimal from 'decimal.js';

export const formatPercentage = (rate: number, precision: number = 2) =>
  new Decimal(rate)
    .mul(100)
    .toDP(precision, Decimal.ROUND_DOWN)
    .toString()
    .concat('%');
